export default __webpack_public_path__ + "static/media/Musica-hombre.e716f7b3.svg";